import { Fragment, useRef, useState } from 'react';
import { formatCurrency } from '@recargas-dominicanas/core/utils';
import { Cell } from '@recargas-dominicanas/core/components';
import { TableRow } from '@recargas-dominicanas/core/components';
import { CellIcon } from '@recargas-dominicanas/core/components';
import { CellImage } from '@recargas-dominicanas/core/components';
import { Menu } from '@recargas-dominicanas/core/components';
import type { CustomerProduct } from '@recargas-dominicanas/core/types/customerProduct.type';
import { MenuOption } from '../../../../components/menu-option/menu-option.component';
import { EditProductModal } from '../edit-product-modal/edit-product-modal.component';
import { style } from './product-item.module.css';

interface Props {
  businessId: number;
  customerId: number;
  customerProduct: CustomerProduct;
}

export function ProductItem(props: Props) {

  const {
    businessId,
    customerId,
    customerProduct
  } = props;

  const menuIconRef = useRef<HTMLDivElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  return (
    <Fragment>
      <TableRow key={customerProduct.id} style={style.tableRow}>
        <CellImage src={customerProduct.product.image}/>
        <Cell weight='medium' text={customerProduct.product.name}/>
        <Cell weight='medium' color='darkgray' text={customerProduct.product.type}/>
        <Cell 
          weight='bold' 
          color='green' 
          text={
            customerProduct.product.profitType === 'fixed'
              ? formatCurrency(customerProduct.profit)
              : customerProduct.profit + '%'
          }/>
        <CellIcon refIcon={menuIconRef} onClick={() => setOpenMenu(true)}/>
      </TableRow>
      <Menu 
        open={openMenu} 
        anchor={menuIconRef}
        onClose={() => setOpenMenu(false)}>
        <MenuOption 
          text='Editar' 
          onClick={() => setOpenEditModal(true)}/>
      </Menu>
      <EditProductModal
        open={openEditModal}
        customerId={customerId}
        businessId={businessId}
        customerProduct={customerProduct}
        onClose={() => setOpenEditModal(false)}/>
    </Fragment>
  );
}
